export default __webpack_public_path__ + "static/media/kg.4f1d3e99.svg";